/// <amd-module name="Environments/Flux/ActionCreatorBase" />
import { Initializable } from "Environments/Flux/Factory";
import { Action as BaseAction } from "VSS/Reflux/Action";

export abstract class ActionCreatorBase extends Initializable {

    public initialize(instanceId?: string): void {
        this._instanceId = instanceId || "";
    }

     /**
     * @brief Returns the instanceId
     */
    public getInstanceId(): string | null {
        return this._instanceId;
    }

    private __dispose(): void {
        this.disposeInternal();
        this._instanceId = null;
    }

    protected abstract disposeInternal(): void;
    private _instanceId: string | null ;
}

export abstract class ActionsHubBase extends Initializable {

}

export class Action<T> extends BaseAction<T> {
    
}
